import moment from 'moment';
import {
  getActualDepartureCars,
  getPlanDepartureCars,
  crudRequest2,
  crudRequest
} from '@/services/api';
import { getToDay } from '@/utils/date';

const [startDate, endDate] = getToDay()
const paramsForm = {
  dateRange: [startDate.clone(), endDate.clone()],
  crrentDateRange: '',
  // crrentDateRange: [startDate.clone().add(-3, 'days').format('YYYY-MM-DD HH:mm:ss'), endDate.clone()],
  centerFilter: '',
  provinceArea: '',
  centerCode: ''
}

export default {
  namespace: 'centerWeightViewNew',
  state: {
    ...paramsForm,
    defualtDateFormat: 'YYYY-MM-DD HH:mm:00',
    onSearch: false,
    tableOffsetHeight: 0,
    datadbName: 'druid',

    dayAggChange: true, // true为按天统计表

    isTmsLoading: false, // tms 接口是否加载完成
    actualDepartureCarsItem: [],  // 已发出 tms
    planDepartureCarsItem: [], // 计划发
    volumeItem: [], // 运力
    actualVolumeList: [] // 实际运力
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload }
      });
      crudRequest('/api/route/centerweightview/search')
      yield put({ type: 'centerWeightViewDepartTableNew/getSelect' });
      // yield put({ type: 'centerWeightViewOutletsTablesNew/getSelect' });
    },
    *getTms(_, { call, put, select }) {
      // tms
      yield put({ type: 'update', payload: { isTmsLoading: false } });
      let query = yield select(({ centerWeightViewNew }) => {
        return {
          locationName: centerWeightViewNew.centerFilter,
          startTime: moment(centerWeightViewNew.dateRange[0]).format(centerWeightViewNew.defualtDateFormat),
          endTime: moment(centerWeightViewNew.dateRange[1]).format(centerWeightViewNew.defualtDateFormat),
        }
      });
      const start = moment(query.startTime).day();
      const volumes = yield crudRequest('/api/route/volumes', {
        // startTime: query.startTime,
        // endTime: query.endTime,
        period: start === 0 ? 7 : start,
        departureCenter: query.locationName
      });
      const actualVolumes = yield crudRequest('/api/route/volumes3', {
        startTime: query.startTime,
        endTime: query.endTime,
        departureCenter: query.locationName
      });
      const volumeItem = volumes.data && volumes.data.length > 0 ? volumes.data : []
      const actualVolumeList = actualVolumes.data && actualVolumes.data.length > 0 ? actualVolumes.data : []
      yield put({
        type: 'update',
        payload: {
          isTmsLoading: true,
          volumeItem: volumeItem,
          actualVolumeList
        },
      });
    },
    *getTmsData({ payload: { scanSite } }, { call, put, select }) {
      let query = yield select(({ centerWeightViewNew }) => {
        return {
          startTime: moment(centerWeightViewNew.dateRange[0]).format('YYYY-MM-DD 12:mm:00'),
          endTime: moment(centerWeightViewNew.dateRange[1]).format('YYYY-MM-DD 12:mm:00'),
        }
      });
      query.locationName = scanSite
      const result3 = yield call(getActualDepartureCars, query);
      const result4 = yield call(getPlanDepartureCars, query);
      return {
        actualDepartureCarsItem: result3.data || [],
        planDepartureCarsItem: result4.data || [],
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
